import { Component } from "react"

/* Components */
import { Pagination } from "../../components"

/* Modal */
import Modal from "react-modal"

/* Redux */
import { connect } from "react-redux"

/* Translate */
import { t } from "../../translates/translate"

/* REST API */
import { activity } from "../../api/Manager"

/* Helpers */
import { utils } from "../../helpers"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"
import { CloseIcon, UsersIcon } from "./ManagerIcons"


/* Fields */
const PERCENTAGE = 95 / 4


/* Widget Manager Activity */
class ManagerActivity extends Component {

    constructor() {
        super()

        this.state = {
            visible: false,
            id: 0,
            name: "",
            status: "loading",
            data: [],
            count: 0,
            page: 1,
        }
    }

    /* Open Action */
    open = ({ id, name }) => {

        this.setState({
            visible: true,
            id: utils.checkValue(id, 0),
            name: utils.checkValue(name, ""),
            status: "loading",
            data: [],
            count: 0,
            page: 1,
        }, () => {
            this.load(1)
        })
    }

    /* Close Action */
    close = () => {
        this.setState({ visible: false, id: 0, name: "", status: "loading", data: [], count: 0, page: 1 })
    }

    /* Load Action */
    load = (page = 1) => {

        /* Fields */
        const { id } = this.state

        /* Set Page */
        this.setState({ page, status: "loading" })

        /* Send to REST API */
        activity({ id, page }).then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data.list, count: response.data.count })
            }
            else {
                this.setState({ status: "error", data: [], count: 0 })
            }
        }).catch(() => {
            this.setState({ status: "error", data: [], count: 0 })
        })

    }

    /* Draw Time */
    _time = (time) => {

        /* Fields */
        const datetime = utils.getTime(time)

        return (
            <div>
                <div className="manager--list-time">{datetime.time}</div>
                <div className="manager--list-date">{datetime.date}</div>
            </div>
        )
    }

    /* Draw Body */
    _body = () => {

        /* Fields */
        const { status, data, count, page } = this.state

        /* Check Status */
        if (status === "loading") {
            return <div className="manager--modal-loading"><LoadingOutlined /></div>
        }

        /* Check Error */
        if (status !== "ok") {
            return <div className="manager--empty"><UsersIcon /><span>{t("swal.generic")}</span></div>
        }

        /* Check Data */
        if (data.length === 0) {
            return <div className="manager--empty"><UsersIcon /><span>{t("manager.noActivity")}</span></div>
        }

        return (
            <div className="manager--modal-body flush">

                <div className="manager--list-header">
                    <div className="number">#</div>
                    <div style={{ width: `${PERCENTAGE}%` }}>{t("manager.game")}</div>
                    <div style={{ width: `${PERCENTAGE * 2}%` }}>{t("manager.action")}</div>
                    <div style={{ width: `${PERCENTAGE}%` }}>{t("manager.dateTime")}</div>
                </div>

                {data.map((item, index) =>
                    <div className="manager--list-row" key={`${index}`}>

                        <div className="manager--list-column number">{(page - 1) * 10 + index + 1}</div>
                        <div className="manager--list-column" style={{ width: `${PERCENTAGE}%` }}>{item.table ? item.table : t("manager.general")}</div>
                        <div className="manager--list-column" style={{ width: `${PERCENTAGE * 2}%` }}>{utils.checkValue(item.text, "-")}</div>
                        <div className="manager--list-column" style={{ width: `${PERCENTAGE}%` }}>{this._time(item.createdAt)}</div>

                    </div>
                )}

                <Pagination size={10} page={page} total={count} onPageChange={(page) => this.load(page)} />

            </div>
        )
    }

    render = () => {

        /* Fields */
        const { visible, name } = this.state

        return (
            <Modal
                isOpen={visible}
                onRequestClose={() => this.close()}
                className="manager--modal wide"
                overlayClassName="manager--overlay"
                closeTimeoutMS={200}
            >

                <div className="manager--modal-header">

                    <div>
                        <h2>{t("manager.activityTitle")}</h2>
                        <p>{name}</p>
                    </div>

                    <div onClick={() => this.close()} className="manager--modal-close">
                        <CloseIcon />
                    </div>

                </div>

                {/* Draw Body */}
                {this._body()}

            </Modal>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps, null, null, { forwardRef: true })(ManagerActivity)
